import request from '@/utils/request';

export function wechatShare() {
  const ajaxurl = window.location.href.split('#')[0];
  return request({
    url: 'https://fc.gz-cmc.com/share/getWechatShareInfo',
    params: {
      url: ajaxurl,
    },
    method: 'get',
  });
}

export function test() {}
